/**
 * Theme Name: project-sscms v1.516.0
 * Theme URI: git+https://github.com/1debit/project-sscms.git
 * Author: Sharp Notions, LLC
 * Author URI: https://sharpnotions.com
 * Description: Wordpress theme for Chime (project-sscms) [main - 034ad85e5]
 * Version: 1.516.0-2025-07-31T18-35-42
 * License: ISC
 * License URI: "http://www.gnu.org/licenses/gpl-2.0.html"
 */
/**
 * File navigation-track.js.
 * Handles sending Segment events for homepage links 
 */

if (typeof jQuery !== 'undefined') jQuery( function($) {

  const navHeaderSelector = 'nav.header__nav';
  const linkSelector = 'a[href]';
  const buttonSelector = '.header__nav-btn';

  // track mouse clicks
  let isMouseClick = false;
  function navMouseTrack(e) {
    isMouseClick = (e.type == 'mousedown');
  }

  function navLinkTrack(e) {
    if (!e.target) {
      return;
    }

    // only track focus events if not a mouse click
    if (e.type == 'focus' && isMouseClick) {
      return;
    }

    // get target link or button element
    const target = $(e.target).closest(linkSelector + ', ' + buttonSelector)[0];

    // If not a nav item, abort
    if (!target) {
      return;
    }
  
    // get the type of target
    const isApply = target.matches('.apply a');
    const isLink = ( !isApply && target.matches(navHeaderSelector + ' ' + linkSelector) );
    const isButton = target.matches(buttonSelector);
    const isNavItem = (isLink || isButton);
    
    // If not a nav item, abort
    if (!isNavItem) {
      return;
    }

    // get link data
    const $target = $(target);
    const linkParent = $target.parents('.sub-menu');
    const isChildItem = $target.find('.menu-item-child__title').length > 0;
    const isSliderItem = $target.hasClass('slider__item-content');
    
    // Determine the link label based on the type of item
    let linkLabel;
    
    if (isLink) {
      if (isChildItem) {
        // For child menu items, combine parent title and child title
        linkLabel = $target.closest('.header__nav-sub-menu').closest('li').find('.menu-item-parent__title-root').text() + 
                   ' - ' + 
                   $target.find('.menu-item-child__title').text();
      } else if (isSliderItem) {
        // For slider items, use only the blurb text
        linkLabel = $target.find('.slider__item-content--blurb').text();
      } else {
        // For normal menu items
        linkLabel = $target.find('.menu-item-parent__title, .menu-item-non-parent__title').first().text() || $target.text();
      }
    } else if (isButton) {
      linkLabel = $target.attr('aria-label');
    } else {
      linkLabel = 'missing label';
    }
    
    const linkLocation = $target.attr('href') || '';
    const level = "" + linkParent.length;
    const eventType = (e.type == 'mouseover') ? 'hover' : e.type;
    const isToggle = (eventType == 'click' && linkLocation == '#');
    // TODO: validate this is correct once experiment menus are created with collapsable sub-menus
    const toggleEvent = isToggle ? ($target.hasClass('sub-menu--show') ? 'collapse' : 'expand') : false;
    const linkEvent = toggleEvent || eventType;
    const screen = isDesktop() ? 'desktop' : 'mobile';

    const properties = {
      interaction_type: "INTERACTION_TYPE_NAVIGATION_BAR_INTERACTION",
      interaction_details: {
        location: linkLocation,
        action_detail: linkLabel,
      },
      additional_data: [
        {
          key: "action",
          value: linkEvent,
        },
        {
          key: "level",
          value: level,
        },
        {
          key: "screen",
          value: screen,
        },
      ],
    }

    segmentGenericEvent('track', properties);

    // Analytics SDK double fire
    fireAnalyticsEvent(Track.WebActionTriggered, {
      unique_id: 'navigation_bar_interaction',
      item_details: {
        "navigation_bar_interaction": {
          "action": linkEvent,
          "button_label": linkLabel,
          "level": level,
        }
      }
    });
  }

  // get nav element
  const nav = document.querySelector(navHeaderSelector);
  if (!nav) {
    return;
  }
  
  // get nav link & button elements
  const navLinks = nav.querySelectorAll(linkSelector + ', ' + buttonSelector);
  for (let c = 0, link; c < navLinks.length; c++) {
    link = navLinks[c];
    link.addEventListener('focus', navLinkTrack);
    link.addEventListener('mouseover', navLinkTrack);
    link.addEventListener('click', navLinkTrack);
  }
  // track key presses
  nav.addEventListener('mousedown', navMouseTrack);
  nav.addEventListener('mouseup', navMouseTrack);
});